import React from 'react';
import { Checkbox } from '@mui/material';
import Box from '../../Box';
import { ArrowDropDownIcon } from '../../icons';
import Popactions from '../../Popactions';
import styled from '@mui/material/styles/styled';
import { isFunction } from '../../../utils';
var ArrowDropDownIconRoow = styled(ArrowDropDownIcon)({
    color: 'rgb(105, 103, 102)',
    cursor: 'pointer',
    position: 'relative',
    top: '3px',
    left: '-3px',
});
var ThRoot = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});
var columnCheckbox = function (options) {
    var _a = (options || {}), selected = _a.selected, checked = _a.checked, allChecked = _a.allChecked, onChange = _a.onChange, onAllChange = _a.onAllChange, onPageAllChange = _a.onPageAllChange;
    return {
        selected: selected,
        checked: checked,
        id: 'columnCheckbox',
        type: 'checkbox',
        width: 52,
        sx: {
            pl: '5px',
            pr: '5px',
        },
        thReader: function (_a) {
            var data = _a.data;
            var handleChange = function (event) {
                var checked = event.target.checked;
                if (onAllChange)
                    onAllChange(checked);
            };
            var actions = [
                (onAllChange && onPageAllChange) && {
                    text: '全选当前页面',
                    onClick: function (popup) {
                        popup.onClose();
                        onAllChange(true);
                    }
                },
                onPageAllChange && {
                    text: '全选所有页',
                    onClick: function (popup) {
                        popup.onClose();
                        onPageAllChange(true);
                    }
                },
            ].filter(function (item) { return !!item; });
            var boolAllChecked = (data && data.length > 0)
                ? (isFunction(allChecked) && allChecked({ data: data }))
                : false;
            var boolIndeterminate = boolAllChecked === false && (selected && selected.length > 0);
            return (React.createElement(ThRoot, null,
                React.createElement(Checkbox, { sx: { pr: 0 }, checked: boolAllChecked, indeterminate: boolIndeterminate, onChange: handleChange }),
                (actions && actions.length > 0) &&
                    React.createElement(Popactions, { actions: actions },
                        React.createElement(ArrowDropDownIconRoow, null))));
        },
        render: function (props) {
            var handleChange = function (event) {
                var checked = event.target.checked;
                if (onChange)
                    onChange(checked, props);
            };
            var getChecked = function () {
                if (typeof checked === 'boolean')
                    return checked;
                if (checked && typeof checked === 'function')
                    return checked(props);
            };
            return (React.createElement(Checkbox, { checked: getChecked(), onChange: handleChange, onClick: function (event) { return event.stopPropagation(); } }));
        },
    };
};
export default columnCheckbox;
